export default __webpack_public_path__ + "static/media/thumbnail.d1b0561a.png";